import { useNavigate } from "react-router-dom";

function Otherclient (){
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/Otherclient/OtherClientsTables');
  };
  const onHandleClick = () => {
    navigate('/Otherclient/OtherClientsData');
  };
  const Click = () => {
    navigate('/Otherclient/AddOtherClients');
  };
  const Clicknav = () => {
    navigate('/Otherclient/CompanyForm');
  };
  const clickbarcode = () => {
    navigate('/Otherclient/Barcode');
  };


  return(
    <div className="main-content">
      <button onClick={Click}>Add Other Clients </button>
      <button onClick={handleClick}>Other Clients Tables</button>
      <button onClick={onHandleClick}>Other Clients Data's</button>
      <button onClick={Clicknav}>Add Company</button>
      <button onClick={clickbarcode}>Barcode</button>
    </div>
  );
}
export default Otherclient;